/**
 * URL修正ユーティリティ
 * 相対URLの絶対URL変換とURL重複修正処理を行う
 */

export interface URLCorrectionConfig {
  patterns: Array<{
    regex: RegExp;
    correction: (matches: string[]) => string;
  }>;
}

/**
 * デフォルトのURL修正設定
 */
export const defaultURLCorrectionConfig: URLCorrectionConfig = {
  patterns: [
    {
      // URL重複パターン: https://domain/events/domain/event/65
      regex: /^(https:\/\/[^/]+)\/events\/([^/]+)\/event\/(\d+)$/,
      correction: (matches) => {
        const [, baseUrl, duplicatedDomain, eventId] = matches;
        const actualDomain = baseUrl.replace('https://', '');
        
        // ドメインが重複していることを確認
        if (duplicatedDomain === actualDomain) {
          return `${baseUrl}/events/${eventId}`;
        }
        return matches[0]; // 修正不要の場合は元のURLを返す
      }
    }
  ]
};

/**
 * URLを修正する
 * @param url 修正対象のURL
 * @param config 修正設定（オプション）
 * @returns 修正されたURL
 */
export const correctURL = (url: string, config: URLCorrectionConfig = defaultURLCorrectionConfig): string => {
  try {
    let correctedUrl = url;

    // 相対URLを絶対URLに変換
    if (correctedUrl.startsWith('/')) {
      correctedUrl = window.location.origin + correctedUrl;
    }

    // 設定されたパターンで修正を試行
    for (const pattern of config.patterns) {
      const match = correctedUrl.match(pattern.regex);
      if (match) {
        const corrected = pattern.correction(match);
        if (corrected !== match[0]) {
          correctedUrl = corrected;
          break;
        }
      }
    }

    return correctedUrl;
  } catch (error) {
    return url; // エラーの場合は元のURLを返す
  }
};

/**
 * 複数のURLパターンを設定可能なURL修正設定を作成
 * @param patterns 追加のパターン配列
 * @returns URL修正設定
 */
export const createURLCorrectionConfig = (patterns: Array<{
  regex: RegExp;
  correction: (matches: string[]) => string;
}>): URLCorrectionConfig => {
  return {
    patterns: [
      ...defaultURLCorrectionConfig.patterns,
      ...patterns
    ]
  };
}; 
